import { useEffect } from 'react';

export function useHandleIntakeChange(
  currentUni: string,
  currentIntake: string,
  isOpen: boolean,
  setValue: (name: string, value: any, options?: { shouldValidate: boolean }) => void,
  intakeOptions: { value: string }[],
) {
  // Set university when drawer opens (but don't fetch intakes - wait for fee status selection)
  useEffect(() => {
    if (isOpen && currentUni) {
      setValue('universityId', currentUni, { shouldValidate: false });
    }
  }, [isOpen, currentUni, setValue]);

  useEffect(() => {
    if (currentIntake && intakeOptions.some(opt => opt.value === currentIntake)) {
      setValue('intakeId', currentIntake, { shouldValidate: false });
    }
  }, [currentIntake, intakeOptions, setValue]);
}
